import {v4 as uuid } from 'uuid';

function updateCustomValues (p) {
    const fields = Object.keys(p);
    this.updateTouched(fields);
    this.customValues = {
        ...this.customValues,
        ...p,
    };
    this.captureFields();
    this.observed.customValues = uuid();
}

export default updateCustomValues;